export const SIDEBAR_WIDTH_VARIABLE = '--sidebar-width'
export const SIDEBAR_WIDTH_COLLAPSED = '100px'
export const SIDEBAR_WIDTH_EXPANDED = '260px'
export const SIDEBAR_COLLAPSED_STORAGE_KEY = 'sidebarCollapsed'
